import React from "react";
import "./PrimaryFilter.css";

interface DropdownSelectProps {
  placeholder: string;
  setActiveSearch: CallableFunction;
}

const PrimaryFilter: React.FC<DropdownSelectProps> = ({
  placeholder,
  setActiveSearch,
}) => {
  // Handle input change (search query)
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setActiveSearch(event.target.value); // Update state with the new input value
  };

  return (
    <div className="dropdownSelectContainer">
      <input
        type="text"
        className="searchInput"
        onChange={handleInputChange} // Capture the input change event
        placeholder={placeholder}
      />
    </div>
  );
};

export default PrimaryFilter;
